/** @format */

import {Chart, CommonChartData} from '../model/charts';

interface ChartWithDummy extends CommonChartData {
  dummy: '';
}

/**
 * Вернёт костыльный график для recharts
 * Этот график необходим для корректного отображения служебных элементов (xAxis и полоска масштабирования)
 * В объекты добавляется ключ dummy, без которого в полоске масштабирования отображаются лишние данные
 * @param charts
 */

const getFakeChart = <ChartId>(charts: Chart<ChartId>[]): ChartWithDummy[] | undefined => {
  if (charts.length) {
    const chart = charts[0].chartsData;
    return chart.map(item => ({name: item.name, dummy: ''}));
  }
};

export default getFakeChart;
